export default "__VITE_ASSET__eDFcCfzH__"